import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataEndChannel } from 'src/app/project/shared/interfaces/data-end-channel.interface';
import { ProjectRouteStationWithParam } from 'src/app/project/shared/interfaces/project-route-station.class';
import { DataEndChannelService } from 'src/app/project/shared/services/data-end-channel.service';
import { DataEndChannelLineParamDialogComponent } from '../data-end-channel-line-param-dialog/data-end-channel-line-param-dialog.component';
import { RouteStationService } from 'src/app/project/shared/services/route-station.service';
import { ChannelLabel, getChannelLabel } from 'src/app/project/shared/functions/channel-label';

@Component({
  selector: 'avs-route-stations-line-param',
  templateUrl: './route-stations-line-param.component.html',
  styleUrls: ['./route-stations-line-param.component.css']
})
export class RouteStationsLineParamComponent implements OnInit {

  @Input() routeStation?: ProjectRouteStationWithParam;
  dataEndChannels: DataEndChannel[] = this.routeStation?.routeStation?.dataEndChannels!;

  changed: boolean = false;
  //den kanal oder die ganze routeStation zurückschicken? 
  sortedChannels: DataEndChannel[] = [];

  constructor(private dataEndChannelService: DataEndChannelService, private dialog: MatDialog, private stationService: RouteStationService) { }

  ngOnInit(): void {
    this.sortedChannels = this.getSortedChannels();
  }

  /** Beschriftung (Typ + Fahrspur/Sensortyp) eines Kanals; Sensortyp via Radar-Verknüpfung. */
  public label(kanal: DataEndChannel): ChannelLabel | null {
    return getChannelLabel(kanal, this.routeStation?.schemaInfo?.radars);
  }

  public deleteKanalsLineParam(kanal: DataEndChannel) {
    //  TODO: https://ramuddenglobal.atlassian.net/browse/RPA-776
    /* methode zum löschen des lineParams */
  }

  getSortedChannels() {
    if (!this.routeStation?.routeStation?.dataEndChannels) return [];
    // Beispielsortierung: erst nach fg, dann nach de
    return this.routeStation.routeStation.dataEndChannels.slice().sort((a, b) => {
      // Zuerst nach fg
      if (a.fg !== b.fg) return a.fg - b.fg;
      // Dann nach localbusAddress
      if (a.localbusAddress !== b.localbusAddress) return a.localbusAddress - b.localbusAddress;
      // Dann nach de
      return a.de - b.de;
    });
  }
  public submitKanalsLineParam(kanal: DataEndChannel) {
    this.dataEndChannelService.editDataEndChannel(kanal.id, kanal).subscribe((response) => {
      if (response) {
        kanal = response;
        this.routeStation!.routeStation!.dataEndChannels!.forEach((x) => {
          if (x.id === kanal.id) {
            x = kanal;
          }
        });
        alert('Erfolgreich gespeichert');
        this.changed = false;
      }
      else {
        alert('Fehler beim Speichern');
      }
    });
  }

  public modelChanged(kanal: DataEndChannel, event: any) {
    this.changed = true;
    kanal.line = event
  }

  public openDeChannels(routeStation: ProjectRouteStationWithParam) {
    /* dialog + ui von rslp */
    const dialogRef = this.dialog.open(DataEndChannelLineParamDialogComponent, { /* doch nicht die ganze routeStation - nochmal mit Jürgen sprechen */
      /*   disableClose: true, */
      data: routeStation,


    })
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.stationService.editProjectRouteStation(routeStation.routeStation!.id, routeStation.routeStation!).subscribe((response) => {
          if (response) {
            routeStation.routeStation = response;
            this.routeStation = routeStation;
          }
          else {
            alert('Fehler beim Speichern');
          }
        });
      }
    })

  }


}
